import _defineProperty from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "content", "theme", "animation", "arrow", "placement", "style", "trigger", "closeRequestKey", "className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { autoUpdate, safePolygon, useClick, useFloating, useFocus, useHover, useInteractions, useRole } from '@floating-ui/react-dom-interactions';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { getArrowPlacement, getMiddleware, getPlacement } from '../../helpers/floating';
/**
 * @see https://floating-ui.com/docs/react-dom-interactions
 */
export var Floating = function Floating(_ref) {
  var _classNames;
  var children = _ref.children,
    content = _ref.content,
    theme = _ref.theme,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? 'duration-300' : _ref$animation,
    _ref$arrow = _ref.arrow,
    arrow = _ref$arrow === void 0 ? true : _ref$arrow,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? 'dark' : _ref$style,
    _ref$trigger = _ref.trigger,
    trigger = _ref$trigger === void 0 ? 'hover' : _ref$trigger,
    closeRequestKey = _ref.closeRequestKey,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var arrowRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var floatingTooltip = useFloating({
    middleware: getMiddleware({
      arrowRef: arrowRef,
      placement: placement
    }),
    onOpenChange: setOpen,
    open: open,
    placement: getPlacement({
      placement: placement
    })
  });
  var context = floatingTooltip.context,
    floating = floatingTooltip.floating,
    _floatingTooltip$midd = floatingTooltip.middlewareData.arrow;
  _floatingTooltip$midd = _floatingTooltip$midd === void 0 ? {} : _floatingTooltip$midd;
  var arrowX = _floatingTooltip$midd.x,
    arrowY = _floatingTooltip$midd.y,
    reference = floatingTooltip.reference,
    refs = floatingTooltip.refs,
    strategy = floatingTooltip.strategy,
    update = floatingTooltip.update,
    x = floatingTooltip.x,
    y = floatingTooltip.y;
  var _useInteractions = useInteractions([useClick(context, {
      enabled: trigger === 'click'
    }), useFocus(context), useHover(context, {
      enabled: trigger === 'hover',
      handleClose: safePolygon()
    }), useRole(context, {
      role: 'tooltip'
    })]),
    getFloatingProps = _useInteractions.getFloatingProps,
    getReferenceProps = _useInteractions.getReferenceProps;
  useEffect(function () {
    if (refs.reference.current && refs.floating.current && open) {
      return autoUpdate(refs.reference.current, refs.floating.current, update);
    }
  }, [open, refs.floating, refs.reference, update]);
  useEffect(function () {
    if (closeRequestKey !== undefined) setOpen(false);
  }, [closeRequestKey]);
  return _jsxs(_Fragment, {
    children: [_jsx("div", _objectSpread(_objectSpread({
      className: theme.target
    }, getReferenceProps({
      ref: reference
    })), {}, {
      "data-testid": "flowbite-tooltip-target",
      children: children
    })), _jsxs("div", _objectSpread(_objectSpread({
      "data-testid": "flowbite-tooltip"
    }, getFloatingProps(_objectSpread({
      className: classNames(theme.base, animation && "".concat(theme.animation, " ").concat(animation), !open && theme.hidden, theme.style[style], className),
      ref: floating,
      style: {
        position: strategy,
        top: y !== null && y !== void 0 ? y : ' ',
        left: x !== null && x !== void 0 ? x : ' '
      }
    }, props))), {}, {
      children: [_jsx("div", {
        className: theme.content,
        children: content
      }), arrow && _jsx("div", {
        className: classNames(theme.arrow.base, (_classNames = {}, _defineProperty(_classNames, theme.arrow.style.dark, style === 'dark'), _defineProperty(_classNames, theme.arrow.style.light, style === 'light'), _defineProperty(_classNames, theme.arrow.style.auto, style === 'auto'), _classNames)),
        "data-testid": "flowbite-tooltip-arrow",
        ref: arrowRef,
        style: _defineProperty({
          top: arrowY !== null && arrowY !== void 0 ? arrowY : ' ',
          left: arrowX !== null && arrowX !== void 0 ? arrowX : ' ',
          right: ' ',
          bottom: ' '
        }, getArrowPlacement({
          placement: floatingTooltip.placement
        }), theme.arrow.placement),
        children: "\xA0"
      })]
    }))]
  });
};